<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 label-width="120px">
            <el-form-item prop="orgNo" :label="$t('org.orgNo')">
                <el-input v-model="dataForm.orgNo" :placeholder="$t('org.orgNo')"></el-input>
            </el-form-item>
            <el-form-item prop="orgName" :label="$t('org.orgName')">
                <el-input v-model="dataForm.orgName" :placeholder="$t('org.orgName')"></el-input>
            </el-form-item>
            <el-form-item prop="orgType" :label="$t('org.orgType')" size="mini">
                <el-radio-group v-model="dataForm.orgType">
                    <el-radio :label="'1'">总部</el-radio>
                    <el-radio :label="'2'">区域</el-radio>
                    <el-radio :label="'3'">公司</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="parentId" :label="$t('org.parentId')" class="org-list">
                <el-popover v-model="orgListVisible" ref="orgListPopover" placement="bottom-start" trigger="click">
                    <el-tree
                            :data="orgList"
                            :props="{ label: 'orgName', children: 'children' }"
                            node-key="id"
                            ref="orgListTree"
                            :highlight-current="true"
                            :expand-on-click-node="false"
                            accordion
                            @current-change="orgListTreeCurrentChangeHandle">
                    </el-tree>
                </el-popover>
                <el-input v-model="dataForm.parentOrgName" v-popover:orgListPopover :readonly="true"
                          :placeholder="$t('org.orgName')"></el-input>
            </el-form-item>
            <el-form-item prop="mobile" :label="$t('org.mobile')">
                <el-input v-model="dataForm.mobile" :placeholder="$t('org.mobile')"
                          :readonly="orgEdit==true"></el-input>
            </el-form-item>
            <el-form-item prop="status" :label="$t('org.status')" size="mini">
                <el-radio-group v-model="dataForm.status">
                    <!--
                    <el-radio :label="0" v-if="!this.dataForm.id">注销</el-radio>
                    -->
                    <el-radio :label="1">正常</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="roleIdList" :label="$t('user.roleIdList')" class="role-list">
                <el-select v-model="dataForm.roleIdList" multiple :placeholder="$t('user.roleIdList')">
                    <el-option v-for="role in roleList" :key="role.id" :label="role.name" :value="role.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import {isEmail, isMobile} from '@/utils/validate'

    export default {
        data() {
            return {
                visible: false,
                orgEdit: false,
                orgList: [],
                orgListVisible: false,
                roleList: [],
                roleIdListDefault: [],
                dataForm: {
                    id: '',
                    orgNo: '',
                    orgName: '',
                    parentId: null,
                    parentOrgName: '',
                    password: '',
                    orgType: '2',
                    mobile: '',
                    memberId: null,
                    status: 1,
                    roleIdList: []
                }
            }
        },
        computed: {
            dataRule() {
                var validateMobile = (rule, value, callback) => {
                    if (!isMobile(value)) {
                        return callback(new Error(this.$t('validate.format', {'attr': this.$t('user.mobile')})))
                    }
                    callback()
                }
                return {
                    orgNo: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    orgName: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    orgType: [
                        {required: true, message: this.$t('validate.required'), trigger: 'change'}
                    ],
                    mobile: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'},
                        {validator: validateMobile, trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.roleIdListDefault = []
                    Promise.all([
                        this.getOrgList(),
                        this.getRoleList()
                    ]).then(() => {
                        if (this.dataForm.id) {
                            this.getInfo()
                        }
                    })
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/list').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/sys/org/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data,
                        roleIdList: []
                    }
                    if (this.dataForm.parentId != null) {
                        this.$refs.orgListTree.setCurrentKey(this.dataForm.parentId);
                    }
                    // 角色配置, 区分是否为默认角色
                    if(res.data.roleIdList!=null) {
                        for (var i = 0; i < res.data.roleIdList.length; i++) {
                            if (this.roleList.filter(item => item.id === res.data.roleIdList[i])[0]) {
                                this.dataForm.roleIdList.push(res.data.roleIdList[i])
                                continue
                            }
                            this.roleIdListDefault.push(res.data.roleIdList[i])
                        }
                    }
                    this.orgEdit = true;
                }).catch(() => {
                })
            },
            // 获取角色列表
            getRoleList () {
                return this.$http.get('/sys/role/supOrg/list').then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.roleList = res.data
                }).catch(() => {})
            },
            // 上级组织机构选中
            orgListTreeCurrentChangeHandle(data, node) {
                this.dataForm.parentId = data.id
                this.dataForm.parentOrgName = data.orgName
                this.orgListVisible = false
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/org', {
                        ...this.dataForm,
                        roleIdList: [
                            ...this.dataForm.roleIdList,
                            ...this.roleIdListDefault
                        ]
                    }).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>

<style lang="scss">
    .mod-sys__user {
        .dept-list {
            .el-input__inner,
            .el-input__suffix {
                cursor: pointer;
            }
        }
        .role-list {
            .el-select {
                width: 100%;
            }
        }
    }
</style>
